export const DOCX_EXTENSION = ".docx";
export const DOCX_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
export const PDF_EXTENSION = ".pdf";
export const PDF_MIME_TYPE = "application/pdf";
export const MP3_EXTENSION = ".mp3";
export const MP3_MIME_TYPE = "audio/mpeg";
export const WAV_EXTENSION = ".wav";
export const WAV_MIME_TYPE = "audio/wav";
export const M4A_EXTENSION = ".m4a";
export const M4A_MIME_TYPE = "audio/mp4";
export const MP4_EXTENSION = ".mp4";
export const MP4_MIME_TYPE = "video/mp4";
